import { pipe } from 'ramda';
import filter from 'lodash/fp/filter';
import groupBy from 'lodash/fp/groupBy';
import Http from '../../http';
import {
  CLOCK_IN_MODAL_CLOSE,
  FETCH_TIMER_STATE,
  START_TIMER,
  STOP_TIMER,
  SET_TIME_TRACKING_BARBERS,
  UPDATE_BARBER_TIME_TRACKING,
  TOGGLE_TIMER,
  ADD_BARBER_TRACK_TIME,
  REMOVE_BARBER_TIME_TRACKING,
  SYNC_BARBER_TRACK_TIME,
} from './constants';

export const startTimer = data => ({
  type: START_TIMER,
  payload: data,
});

export const startTimerBarber = barberId => dispatch =>
  Http
    .post(`/barber/${barberId}/time-track`)
    .then(data => dispatch(startTimer(data)));

export const startTimerShop = shopId => dispatch =>
  Http
    .post(`/shop/${shopId}/time-track`)
    .then(data => dispatch(startTimer(data)));

export const stopTimer = data => ({
  type: STOP_TIMER,
  payload: data,
});

export const stopTimerBarber = barberId => dispatch =>
  Http
    .post(`/barber/${barberId}/time-track`)
    .then(data => dispatch(stopTimer(data)));

export const stopTimerShop = shopId => dispatch =>
  Http
    .post(`/shop/${shopId}/time-track`)
    .then(data => dispatch(stopTimer(data)));

export const toggleTimer = () => ({
  type: TOGGLE_TIMER,
});

const fetchTimerState = data => ({
  type: FETCH_TIMER_STATE,
  payload: data,
});

export const fetchTimerBarber = barberId => dispatch =>
  Http
    .get(`/barber/${barberId}/time-track/active`)
    .then(data => dispatch(fetchTimerState(data)));

export const fetchTimerShop = shopId => dispatch =>
  Http
    .get(`/shop/${shopId}/time-track/active`)
    .then(data => dispatch(fetchTimerState(data)));

export const clockInModalClose = () => ({
  type: CLOCK_IN_MODAL_CLOSE,
});

const setTimeTrackingBarbers = payload => ({
  type: SET_TIME_TRACKING_BARBERS,
  payload,
});

const fetchTimeTrackingBarbers = (url, filters = {}) => dispatch =>
  Http
    .get(url, filters)
    .then((data) => {
      const barberEntries = pipe(
        filter('barberId'),
        groupBy('barberId'),
      )(data.rows);
      dispatch(setTimeTrackingBarbers(barberEntries));
    });

export const fetchShopTimeTrackingBarbers =
  (shopId, filters) => fetchTimeTrackingBarbers(`/shop/${shopId}/time-track`, filters);
export const fetchBarberTimeTrackingBarbers =
  (barberId, filters) => fetchTimeTrackingBarbers(`/barber/${barberId}/time-track`, filters);

const updateBarberTimeTracking = payload => ({
  type: UPDATE_BARBER_TIME_TRACKING,
  payload,
});
export const timeTrackingBarberToggle = (barberId, data) => dispatch =>
  Http
    .post(`/barber/${barberId}/time-track`, data)
    .then((responseData) => {
      dispatch(updateBarberTimeTracking(responseData));
      return responseData;
    });

export const updateTimeEntry =
  (barberId, entryId, data) => dispatch =>
    Http.put(`/barber/${barberId}/time-track/${entryId}`, data)
      .then(entry => dispatch(updateBarberTimeTracking(entry)));

export const removeTimeEntry = (barberId, { id, passcode, shopId }) => dispatch =>
    Http.delete(`/barber/${barberId}/time-track/${id}`, { passcode, shopId })
      .then(() => dispatch({
        type: REMOVE_BARBER_TIME_TRACKING,
        payload: { shopId, barberId, id, passcode },
      }));

const addBarberTrackTimeAction = payload => ({
  type: ADD_BARBER_TRACK_TIME,
  payload,
});
export const addBarberTrackTime =
  (barberId, data) => dispatch =>
    Http.post(`/barber/${barberId}/time-track/add`, data)
      .then(entry => dispatch(addBarberTrackTimeAction(entry)));

export const syncTimeTrack = (entry, ownerId, ownerType) => ({
  type: SYNC_BARBER_TRACK_TIME,
  payload: { timeTrackEntry: entry, ownerId, ownerType },
});

export const getTimeTrackEntry = (entryId, ownerId, ownerType) => (
  Http.get(`/${ownerType}/${ownerId}/time-track/${entryId}`)
);
